import { render, staticRenderFns } from "./BankCard.vue?vue&type=template&id=6f9a1895&scoped=true"
import script from "./BankCard.vue?vue&type=script&lang=js"
export * from "./BankCard.vue?vue&type=script&lang=js"
import style0 from "./BankCard.vue?vue&type=style&index=0&id=6f9a1895&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9a1895",
  null
  
)

export default component.exports